import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { postComment } from '../../../api/comments';

import { generateItemCIDKey } from '../../Items/utils/generateItemCIDKey';
import { mergeCommentWithUserData } from '../../../utils/comments';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';
import { generateCommentCIDKey } from '../utils/generateCommentCIDKey';

export const createComment = createAsyncThunk(
  'comments/createComment',
  async (commentData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentResponse, userdataResponse] = await postComment(
        commentData,
        {
          cancelToken: source.token,
        },
      );
      return mergeCommentWithUserData(commentResponse, userdataResponse);
    } catch (error) {
      return rejectWithValue(error.response.status);
    }
  },
);

export const createCommentExtraReducers = {
  [createComment.pending]: (state, action) => {
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    checkAndSetLoadingWithId(
      state.comments.comment.actions.create.request,
      action,
      itemCIDKey,
    );
  },
  [createComment.fulfilled]: (state, action) => {
    const {
      payload,
      meta: { arg },
    } = action;
    const { inReplyTo } = arg.body;
    const itemCIDKey = generateItemCIDKey(arg.path);
    const parentCIDKey = generateCommentCIDKey({
      ...arg.path,
      commentId: inReplyTo,
    });

    onMatchedRequest(
      state.comments.comment.actions.create.request[itemCIDKey],
      action,
      () => {
        const commentCIDKey = generateCommentCIDKey(payload);
        state.comments.comment.byId[commentCIDKey] = payload;
        state.comments.comment.allIds.push(commentCIDKey);

        if (!inReplyTo && !state.comments.item.byId[itemCIDKey]) {
          state.comments.item.byId[itemCIDKey] = [];
        }
        if (
          !inReplyTo &&
          !state.comments.item.byId[itemCIDKey].includes(commentCIDKey)
        ) {
          state.comments.item.byId[itemCIDKey].unshift(commentCIDKey);
        }

        if (inReplyTo) {
          if (!state.comments.parent.byId[parentCIDKey]) {
            state.comments.parent.byId[parentCIDKey] = [];
          }

          if (
            !state.comments.parent.byId[parentCIDKey].includes(commentCIDKey)
          ) {
            state.comments.parent.byId[parentCIDKey].unshift(commentCIDKey);
            state.comments.comment.byId[parentCIDKey].metadata.replies += 1;
          }
        }

        if (
          !state.comments.parent.byId[commentCIDKey] &&
          payload.metadata.replies > 0
        ) {
          state.comments.parent.byId[commentCIDKey] = [];
        }
      },
    );
  },
  [createComment.rejected]: (state, action) => {
    const itemCIDKey = generateItemCIDKey(action.meta.arg.path);

    handleRequestRejection(
      state.comments.comment.actions.create.request[itemCIDKey],
      action,
    );
  },
};
